'use client';

import { cn } from '@/shared/utils/tw';
import type { Toast } from '../types/toast-types';

interface ToastTextProps {
  toast: Toast;
}

/**
 * Toast-Text: 기본 텍스트 토스트
 */
export const ToastText = ({ toast }: ToastTextProps) => (
  <div
    className={cn(
      'bg-[rgba(255,255,255,0.2)]',
      'backdrop-blur-[20px]',
      '[-webkit-backdrop-filter:blur(20px)]',
      'rounded-full',
      'px-[18px] py-2',
      'font-pretendard text-sm font-normal text-white',
      'pointer-events-auto',
      toast.isExiting ? 'animate-toast-exit' : 'animate-toast-enter'
    )}
  >
    {toast.message}
  </div>
);
